import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { UsuarioService } from '@account/usuario.service';
import { AerovaleDetalleComponent } from '@despacho/aerovale-detalle/aerovale-detalle.component';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { CierreTurno } from '@shared/models/cierreTurno/CierreTurno';
import { Precierre } from '@shared/models/cierreTurno/Precierre';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Contenedor } from '@shared/models/stock/Contenedor';
import { Responsable } from '@shared/models/stock/Responsable';
import { MessageService } from '@shell/message.service';
import { AbastecedoraService } from '@stock/abastecedoras.service';
import { GenerarInformeAerovalesComponent } from './generar-informe-aerovales/generar-informe-aerovales.component';
import { PrecierreAbastecedoraComponent } from './precierre-abastecedora/precierre-abastecedora.component';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { AerovalesService } from '@despacho/aerovales.service';
import { Remito } from '@shared/models/facturacion/Remito';
import { EstadoCierre } from '@shared/enums/estadoCierre';
import { ProductoService } from '@abm/producto/producto.service';
import { Producto } from '@shared/models/despacho/Producto';
import { TipoExpendedora } from '@shared/enums/tipoExpendedora';
import { SharedService } from '@shared/shared.service';
import { CierreDiarioService } from '../services/cierre-diario.service';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { EtapasCierre } from '@shared/enums/EtapasCierreTurno';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-realizar-cierre-turno',
  templateUrl: './realizar-cierre-turno.component.html',
  styleUrls: ['./realizar-cierre-turno.component.css']
})
export class RealizarCierreTurnoComponent implements OnInit, OnDestroy {

  aeroplanta: Aeroplanta;
  abastecedoras: Contenedor[] = [];
  abastecedorasAux: Contenedor[] = [];
  tablaAbastecedoras: UntypedFormGroup;
  loading: boolean = false;
  messageSpinner: string = 'C A R G A N D O    P R E C I E R R E . . .';
  realizandoCierre: boolean = false;
  noContinua: boolean = false;

  hayCierre: CierreTurno;
  pasaPagina: boolean = false;
  cierreRealizoContinuado: CierreTurno;
  codigoAeroplanta: string = '';
  responsable: Responsable;
  change$: Subscription;
  remitosContadoSF: Remito[];
  hayRemitoVencidos: boolean = false;
  mostrarTablaRemitosContado: boolean = false;
  aerovaleDetalle: AerovaleDetalle;
  obteniendoAerovale: boolean = false;
  bloquearBotones: boolean = false;
  consultandoSiHayRemitosSF: boolean = false;
  aerovaleSeleccionado: number = null;
  productos: Producto[] = [];
  cargandoProductos: boolean = false;

  EstadoCierre = EstadoCierre;

  constructor(
    private activeModal: NgbModal,
    private usuarioService: UsuarioService,
    private productoService: ProductoService,
    private comprobanteService: ComprobanteService,
    private fb: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private cierresService: CierreDiarioService,
    private abastecedoraService: AbastecedoraService,
    private messageService: MessageService,
    private aerovaleService: AerovalesService,
    private datePipe: DatePipe,
    private sharedService: SharedService) {
    this.tablaAbastecedoras = this.fb.group({
      abastecedoraFormControl: new UntypedFormControl(),
      aforadorLeidoFormControl: new UntypedFormControl(),
      estadoFormControl: new UntypedFormControl(),
      fechaHoraPrecierreFormControl: new UntypedFormControl(),
    });
    this.change$ = sharedService.aeroplantaSeleccionada.subscribe(() => {
      this.cambiarDeAeroplanta()
    });
  }

  // hooks

  ngOnInit() {
    this.startPage();
  }

  startPage() {
    this.cierresService.cargandoCierre();
    this.responsable = new Responsable();
    this.responsable.NombreCompleto = this.usuarioService.getNombresCompletosUsuario();
    this.responsable.DNI = this.usuarioService.getDniUsuario();
    this.responsable.UserName = this.usuarioService.getUsername();
    this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.remitosContadoSF = null;
    this.hayRemitoVencidos = false;
    this.mostrarTablaRemitosContado = false;
    this.getProductos();
    this.getEstadoCierre();
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
  }

  cambiarDeAeroplanta() {
    this.startPage();
  }

  // llamadas al service

  getProductos() {
    this.cargandoProductos = true;
    this.productoService.obtenerProductos()
      .subscribe(result => {
        this.productos = result.filter(p => p.rubro.aerocombustible || p.rubro.combustible).filter(p => p.activo);
        this.cargandoProductos = false;
      }, () => this.cargandoProductos = false);
  }

  getAbastecedoras(cierre: CierreTurno) {
    this.noContinua = false;
    this.abastecedoraService.getExpendedorasPorCierre(cierre.id, this.codigoAeroplanta)
      .subscribe(result => {
        this.abastecedoras = result;
        this.abastecedorasAux = result;
        if (this.abastecedoras.length > 0) {
          for (let j = 0; this.hayCierre.precierres.length > j; j++) {
            for (let i = 0; this.abastecedoras.length > i; i++) {
              if (this.abastecedoras[i].codigo == this.hayCierre.precierres[j].codigoExpendedora) {
                const num = this.abastecedorasAux.indexOf(this.abastecedoras[i]);
                this.abastecedorasAux.splice(num, 1);
              }
            }
          }
          const precierreAux: Precierre[] = [];
          for (let j = 0; this.abastecedorasAux.length > j; j++) {
            precierreAux.push(new Precierre());
            precierreAux[j].codigoExpendedora = this.abastecedorasAux[j].codigo;
            precierreAux[j].nombreExpendedora = this.abastecedorasAux[j].nombre;
            precierreAux[j].codigoProducto = this.abastecedorasAux[j].productoActual.codigoProducto;
            precierreAux[j].nombreProducto = this.abastecedorasAux[j].productoActual.nombreProducto;
            precierreAux[j].estadoDeCierre = 1;
            this.noContinua = true;
          }
          for (const p of precierreAux) {
            this.hayCierre.precierres.push(p);
          }
          this.hayCierre.precierres.sort((a, b) => a.nombreExpendedora.toLocaleUpperCase() > b.nombreExpendedora.toLocaleUpperCase() ? 1 : -1);
          this.handleSpinner(false);
        }
        else {
          this.abastecedoras = [];
          this.handleSpinner(false);
        }

      })
  }

  handleSpinner(loading: boolean) {
    this.loading = loading;
    loading ? this.spinner.show('spinnerAbastecedoras') : this.spinner.hide('spinnerAbastecedoras');
    this.cierresService.loading.set(loading);
  }

  getEstadoCierre(refresh?: boolean) {
    this.handleSpinner(true);
    this.cierresService.getCierreTurno(this.codigoAeroplanta)
      .subscribe(result => {
        this.hayCierre = result;
        if (!this.encontroCierres()) {
          this.cierresService.getCierreSegunEstado(this.codigoAeroplanta, EstadoCierre.Abierto)
            .subscribe(result => {
              this.hayCierre = result;
              if (this.encontroCierres()) {
                this.getAbastecedoras(this.hayCierre);
                if (this.hayCierre) {
                  this.verificarRemitosContadoSF();
                }
              } else {
                this.messageService.showErrorMessage('Hubo un error al obtener el estado del cierre.');
                this.handleSpinner(false);
              }
              this.cierresService.cargoCierre();
            });
        } else {
          this.getAbastecedoras(this.hayCierre);
          if (this.hayCierre) {
            this.cierresService.setCierre(this.hayCierre);
            if (refresh) this.completeStep(EtapasCierre.RealizarCierre - 1, this.hayCierre);
            if(this.cierresService.ingresoPrimeraVez)this.verificarEtapa();
            this.verificarRemitosContadoSF();
          }
          this.cierresService.cargoCierre();
        }
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al obtener el estado del cierre.');
        this.handleSpinner(false);
        this.cierresService.cargoCierre();
      });
  }

  encontroCierres(): boolean {
    return this.hayCierre != null ? true : false;
  }

  verificarRemitosContadoSF() {
    this.consultandoSiHayRemitosSF = true;
    this.mostrarTablaRemitosContado = false;
    this.comprobanteService.getRemitosSinFacturar(this.codigoAeroplanta)
      .subscribe(result => {
        this.remitosContadoSF = result;
        this.consultandoSiHayRemitosSF = false;
        if (this.remitosContadoSF.length > 0) {
          this.mostrarTablaRemitosContado = true;
          this.remarcarRemitos(this.remitosContadoSF);
          setTimeout(() => {
            const tabla = document.getElementById("tablaRemitos");
            tabla?.scrollIntoView();
          }, 500);
        }
      }, () => {
        this.consultandoSiHayRemitosSF = false;
      });
  }

  validarPrecierres(precierres: Precierre[]) {
    let densidadOk: boolean = false;
    let tempOk: boolean = false;
    for (const precierre of precierres) {
      if (precierre.tipoExpendedora == TipoExpendedora.ABASTECEDORA_CAMION) {
        const productoSeleccionado = this.productos.find(p => p.codigoProducto == precierre.codigoProducto);
        densidadOk = (precierre.densidad >= productoSeleccionado.densidadMin && precierre.densidad <= productoSeleccionado.densidadMax);
        tempOk = (precierre.temperatura <= 100 && precierre.temperatura > -50);
        //nivel = (precierre.nivel > 0 && precierre.nivel15 > 0);
        if (!densidadOk || !tempOk) { // || !nivel
          !densidadOk ? this.messageService.showErrorMessage(`La Densidad de la Expendedora ${precierre.codigoExpendedora} debe estar \n dentro del rango del producto ${productoSeleccionado.densidadMin} - ${productoSeleccionado.densidadMax}`) : null;
          !tempOk ? this.messageService.showErrorMessage(`La Temperatura de la Expendedora ${precierre.codigoExpendedora} no puede ser mayor a 100° ó menor a -50°`) : null;
          //!nivel ? this.messageService.showErrorMessage(`El nivel de la Expendedora ${precierre.codigoExpendedora} debe ser mayor que 0.`) : null;
          return false;
        }
      }
    }
    return true;
  }


  verificarEtapa() {
    if (this.hayCierre?.etapaActual > EtapasCierre.RealizarCierre && this.hayCierre?.etapaActual <= EtapasCierre.ParteDiario && !this.hayCierre?.parteDiario?.guardado && !(this.hayCierre?.estadoCierre == EtapasCierre.CargarDatos && this.hayRemitoVencidos)) {
      this.cierresService.changeStepProgress(this.hayCierre.etapaActual)
    } else if (this.hayCierre.etapaActual == EtapasCierre.ParteDiario && this.hayCierre?.parteDiario?.guardado) {
      const modalRef = this.activeModal.open(ModalConfirmComponent);
      const fecha = this.datePipe.transform(this.hayCierre.fechaHoraCierre, 'dd/MM/yyyy');
      modalRef.componentInstance.titulo = "El cierre del día " + fecha + " no esta finalizado.";
      modalRef.componentInstance.mensaje = "¿Desea finalizar el cierre preexistente? En el caso de cancelar el cierre de turno quedará pendiente de finalización.";
      modalRef.result.then((result) => {
        if (result == 'Si') {
          this.messageSpinner = 'F I N A L I Z A N D O     C I E R R E . . .';
          this.handleSpinner(true);
          this.cierresService.modificarParteDiario(this.hayCierre.parteDiario, true).subscribe(() => {
            this.finalizarTurno();
          },
            () => {
              this.messageService.showErrorMessage('Hubo un error al generar el parte diario, por favor reintente');
              this.handleSpinner(false);
            });
        }
      }, () => { 
        this.cierresService.changeStepProgress(this.hayCierre.etapaActual); 
      });
    }
  }

  finalizarTurno() {
    this.cierresService.finalizarTurno(this.hayCierre.id).subscribe(() => {
        this.messageService.showSuccessMessage('El turno fue finalizado exitosamente.');
        this.handleSpinner(false);
        this.cierresService.updateStepProgress(EtapasCierre.ParteDiario, this.hayCierre);
      }, () => {
        this.handleSpinner(false);
        this.messageService.showErrorMessage('Ha habido un problema al finalizar el turno.');
        this.getEstadoCierre();
      }
    )
  }

  realizarCierre() {
    if (this.validarPrecierres(this.hayCierre.precierres)) {
      this.handleSpinner(true);
      this.messageSpinner = 'G U A R D A N D O     P R E C I E R R E . . .';
      this.realizandoCierre = true;
      if (this.hayCierre.estadoCierre == EstadoCierre.Abierto || this.hayCierre.estadoCierre == EstadoCierre.Cerrado) {
        this.cierresService.postCierreIniciacion(this.codigoAeroplanta, this.responsable)
          .subscribe(result => {
            this.pasaPagina = true;
            this.realizandoCierre = false;
            this.handleSpinner(false);
            this.cierreRealizoContinuado = result;
            this.cierresService.setCierre(result);
            this.completeStep(EtapasCierre.RealizarCierre, this.cierreRealizoContinuado);
          }, (err: ErrorModel) => {
            this.messageService.showErrorMessage('Hubo un error al cerrar el turno' + err.description);
            this.realizandoCierre = false;
            this.handleSpinner(false);
          });
      }
    }
  }

  completeStep(index: EtapasCierre, cierre: CierreTurno): void {
    this.cierresService.updateStepProgress(index, cierre);
  }



  precerrarAbastecedora(p: Precierre) {
    const modalRef = this.activeModal.open(PrecierreAbastecedoraComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.precierre = p;
    modalRef.componentInstance.cierreId = this.hayCierre.id;
    modalRef.result.then(result => {
      if (result == true) {
        this.getEstadoCierre(true);
      }
    }, () => {
      console.log("aaa");
    });
  }

  obtenerAerovale(id: string, i: number) {
    this.bloquearBotones = true;
    this.aerovaleDetalle = null;
    this.aerovaleSeleccionado = i;
    this.aerovaleService.getAerovalePorIdyTipo(id)
      .subscribe(result => {
        this.aerovaleDetalle = result;
        this.aerovaleSeleccionado = null;
        this.bloquearBotones = false;
        if (this.aerovaleDetalle != null) {
          this.mostrarAerovale();
        }
      }, (err: ErrorModel) => {
        this.messageService.showErrorMessage('Hubo un error al obtener el Aerovale' + err.description);
        this.aerovaleSeleccionado = null;
        this.bloquearBotones = false;
      });
  }

  mostrarAerovale() {
    const modalRef = this.activeModal.open(AerovaleDetalleComponent, { size: "lg", centered: true })
    modalRef.componentInstance.aerovaleDetalle = this.aerovaleDetalle;
  }

  modalGenerarInforme() {
    const modalRef = this.activeModal.open(GenerarInformeAerovalesComponent, { centered: true, backdrop: 'static', size: 'lg', windowClass: 'myCustomModalClass' });
    modalRef.componentInstance.cierreTurno = this.hayCierre;
  }

  remarcarRemitos(rem: Remito[]) {
    const fechaHoy = new Date;
    const dias = 2;
    fechaHoy.setDate(fechaHoy.getDate() - dias);
    this.hayRemitoVencidos = false;
    rem.forEach(e => {
      const fechaRemito = new Date(e.fechaHoraCreacion);
      if (fechaRemito < fechaHoy) {
        e.vencido = true;
        this.hayRemitoVencidos = true;
      } else {
        e.vencido = false;
      }
      e.fechaLimite = this.sharedService.formatDate(fechaRemito.getFullYear(), fechaRemito.getMonth() + 1, fechaRemito.getDate() + dias, fechaRemito.getHours(), fechaRemito.getMinutes());
    });
  }
}
